import {
  fetchDeleteSubCategoryFailure,
  fetchDeleteSubCategorySuccess,
} from "./reducer";
import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { DELETE_SUBCATEGORY } from "../../constants/constants";
import { getAllCategory } from "../GetCategory/thunk";

export const deleteSubCategory =
  (categoryId, subCategoryId, setLoading) =>
  (dispatch) => {
    setLoading(true);

    determineBaseUrlAndPerformApiCall(
      DELETE_SUBCATEGORY(categoryId, subCategoryId),
      "DELETE",
    )
      .then((response) => {
        if (!response.error) {
          dispatch(fetchDeleteSubCategorySuccess(response));

          dispatch(getAllCategory(setLoading));

          setLoading(false);

          toast.success("SubCategory Deleted Successfully");
        }

        if (response.error) {
          dispatch(
            fetchDeleteSubCategoryFailure(response.error.message),
          );

          setLoading(false);

          toast.error(response.error.message);
        }
      })
      .catch((errorResp) => {
        dispatch(
          fetchDeleteSubCategoryFailure(
            errorResp?.message || "Something went wrong",
          ),
        );

        setLoading(false);

        toast.error(errorResp?.message || "Something went wrong");
      });
  };